export default __webpack_public_path__ + "static/media/pic67.e4b06817.jpg";